// @flow
import {type SagaIterator} from 'redux-saga';
import {sendHashedEmailEvent} from '@optimaxdev/analytics/mobile';

import type {ActionType} from 'constants/flow/flowTypes';
import {CONTACTS} from 'constants/actions';

import type {DataType} from 'containers/contacts/contacts';
import {takeLatest, put, putResolve, call, delay} from 'redux-saga/effects';
import {sendUserData, setNotification, setGratitude} from 'actions/contacts/contacts';

/**
 * Sets notification popup on contacts page with server response which will be disappears after delay
 * @param {string} message - Received message for notification
 */
export function* setNotificationSaga(message: string): SagaIterator {
    const showNotification = yield call(setNotification, message);
    yield put(showNotification);
    yield delay(3000);
    const closeNotification = yield call(setNotification, '');
    yield put(closeNotification);
}

/**
 * Sets 'thank you' content for button which will be disappears after delay
 * @param {boolean} gratitudeVisibility - Visibility of gratitude on submit button
 */
export function* setThanksSaga(gratitudeVisibility: boolean): SagaIterator {
    if (gratitudeVisibility) {
        const showGratitude = yield call(setGratitude, true);
        yield put(showGratitude);
    } else {
        yield delay(10e3);
        const closeGratitude = yield call(setGratitude, false);
        yield put(closeGratitude);
    }
}

/**
 * Shows 'thank you' message which will disappear after delay
 */
export function* showThanksMessage(): SagaIterator {
    const showGratitude = yield call(setGratitude, true);
    yield put(showGratitude);
    yield delay(4000);
    const closeGratitude = yield call(setGratitude, false);
    yield put(closeGratitude);
}

/**
 * Sends users data from form to backend and maybe even receive something
 * @param {ActionType<DataType>} action - Received action
 */
export function* sendFormData({payload: userData}: ActionType<DataType>): SagaIterator {
    const {
        value: {
            data: {message, error},
        },
    } = yield putResolve(sendUserData(userData));
    if (error) yield call(setNotificationSaga, message);
    else yield call(sendHashedEmailEvent, userData.email);
    yield call(showThanksMessage);
}

/**
 * Begin of contacts page root saga
 */
export default function* contactsPageSaga(): SagaIterator {
    yield takeLatest(CONTACTS.START_SEND_USERS_DATA_SAGA, sendFormData);
}
